<template>
  <v-card flat tile
          :color="lessonColor"
          class="body-2 lesson"
          :class="{'grey--text text--darken-3':isPast,
          'lesson-recorded': record}"
          v-bind:style="{'border-color': markerColor}"
          :loading="loading?'primary':null"
          @click.stop="lessonInfoDialog = true"
  >
    <v-container grid-list-md fluid>
      <v-layout row wrap align-center>
        <v-flex xs3 md2>
          <v-layout row align-center>
            <div v-if="record && record.missedRecord" class="lesson-icon-is-work-out">O</div>
            <div>
              <div v-if="showDate">{{ lessonDate }}</div>
              <div>{{ lesson.beginTime}}-{{ lesson.endTime}}</div>
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs9 md2>
          <div>{{ className }}
            <v-icon v-if="hasVideo" class="lesson-icon-video">mdi-youtube</v-icon>
            <v-icon v-if="hasWebinar" class="lesson-icon-webinar">mdi-video</v-icon>
          </div>
          <div class="caption">
            <span>{{ filialName }}, </span>
            <span v-if="teachers.length">{{ teachers }}, </span>
            {{ roomName }}
          </div>
          <div class="caption accent--text" v-if="comment">{{ comment }}</div>
          <div class="caption" style="white-space: pre-wrap">{{ lesson.topic }}</div>
          <div class="caption mt-2" v-if="record && record.missedRecord">
            <div>Отработка за пропуск:</div>
            <div class="grey--text text--darken-2">
              <div>{{ missedLesson.classTitle }}</div>
              <div>{{ missedLesson.date }} {{ record.missedRecord.beginTime }} - {{ record.missedRecord.endTime }}</div>
              <div>
                {{ missedLesson.filialName }}
                <span v-if="missedLesson.teachers.length">, {{ missedLesson.teachers }}</span>
              </div>
            </div>
          </div>
          <div class="d-md-none d-flex marker" :style="stylesLesson">{{ task('lesson') }}</div>
          <div class="d-md-none d-flex marker" :style="stylesHome">{{ task('home') }}</div>
        </v-flex>
        <v-flex class="d-none d-md-block lesson-task-flex">
            <div :style="stylesLesson" class="marker">{{ task('lesson') }}</div>
            <div :style="stylesHome" class="marker">{{ task('home') }}</div>
        </v-flex>
        <v-flex  xs3 md2 class="text-left text-md-center">
          <span v-if="!record && canRecord && lesson.freeRecords!==null">
            Ост. {{ lesson.freeRecords}} мест
          </span>
          <span v-if="!record && canRecord && lesson.freeRecords===null && classFreeRecords">
            Ост. {{ classFreeRecords }} мест
          </span>
          <div
            v-if="classPayType === 'lessons'
            && lesson.status===1
            && record
            && !record.free
            && !record.goodReason
            && (record.bill && !record.bill.userSubscriptionId)"
            class="red--text">В долг
          </div>

          <div
            v-if="classPayType === 'lessons'
                  && record
                  && record.bill
                  && record.bill.userSubscriptionId
                  && UISettings.showSubsDebits
                  && (!record.workOffRecord || (
                    record.workOffRecord
                    && (record.bill.summa || record.bill.lessonsCount)
                  ))"
            class="grey--text text--darken-2 body-2">
            <money :sum="-record.bill.summa"></money>
            <div>
              Аб. №{{ userSubscriptionId }}
            </div>
          </div>

          <div
            v-if="classPayType === 'lessons'
                  && record
                  && record.bill
                  && record.bill.userSubscriptionId
                  && record.workOffRecord
                  && !record.bill.summa
                  && !record.bill.lessonsCount"
            class="grey--text text--darken-2 body-2">
            <div>
              Отработка
            </div>
          </div>


          <div
            v-if="record && record.test">Пробное</div>
          <div
            v-if="record && record.goodReason">Болеет/отпуск</div>
          <div
            v-if="record && record.free" class="green--text">Бесплатно</div>
        </v-flex>
        <v-flex  xs8 md2 class="text-left text-md-center">
          <div v-if="lesson.status && record">
          <span v-if="record.visit" class="font-weight-bold" :class="{ 'green--text': !missedLesson, 'purple--text' : !!missedLesson}">
            Посетил
          </span>
            <span v-if="!record.visit" class="red--text font-weight-bold">
            Пропуск
          </span>
          </div>
          <v-btn small
                 color="error"
                 @click.stop="cancelDialog=true"
                 v-if="canCancelRecord && record && !lesson.status">Отменить
          </v-btn>
          <v-btn small rounded depressed
                 color="primary"
                 v-if="canRecord && !isRecordFrozen && !record && !lesson.status"
                 @click.stop="createRecord">Записаться
          </v-btn>
          <v-btn small rounded
                 color="disabled"
                 :class="{ 'no-click': true }"
                 v-if="isRecordFrozen && !record">Абонемент заморожен
              </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <lesson-popup :lesson="lesson"
                  v-if="lessonInfoDialog"
                  v-model="lessonInfoDialog"
                  v-on:record="createDialog=true"
                  v-on:cancelRecord="cancelDialog=true">
    </lesson-popup>
    <create-record-popup
      :lesson="lesson"
      v-model="createDialog"
      v-on:change="changeRecord"></create-record-popup>
    <cancel-record-popup
      :lesson="lesson"
      v-model="cancelDialog"
      v-on:change="changeRecord"></cancel-record-popup>
    <v-snackbar v-model="errorCancelRecord" top right color="error">
      Не удалось отменить записать на занятие
    </v-snackbar>
  </v-card>
</template>

<script>
import tinycolor from 'tinycolor2';
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import Money from '@/components/Money';
import {
  getClassName,
  getClassColor,
  checkAllowRecord,
  checkCancelRecord,
  checkIfFrozen,
  newAnswerStatus,
  answerStatusMap,
} from '../../lib/classHelpers';
import loadBaseInfo from '../../lib/baseInfoHelpers';
import LessonPopup from './LessonPopup.vue';
import CreateRecordPopup from './CreateRecordPopup.vue';
import CancelRecordPopup from './CancelRecordPopup.vue';

export default {
  name: 'UserLessonCard',
  components: {
    Money, CancelRecordPopup, CreateRecordPopup, LessonPopup,
  },
  props: ['lesson', 'showDate'],
  data: () => ({
    cancelDialog: false,
    createDialog: false,
    lessonInfoDialog: false,
    loading: false,
    errorRecord: false,
    errorCancelRecord: false,
    stylesHome: '',
    stylesLesson: '',
  }),
  computed: {
    userSubscriptionId() {
      if (this.record.userSubscription && this.record.userSubscription.externalId
        && this.$store.state.UISettings.userSubscriptionExternalIdIncluded) {
        const { externalId } = this.record.userSubscription;
        return externalId.length > 6 ? `${externalId.slice(0, 6)}...` : externalId;
      }
      return this.record.bill.userSubscriptionId;
    },
    lessonDate() {
      return moment(this.lesson.date).format('DD.MM.YY');
    },
    lessonColor() {
      const color = getClassColor(this.lesson.classId);
      if (this.isPast) {
        return tinycolor(color).lighten(4).toHexString();
      }
      return color;
    },
    className() {
      return getClassName(this.lesson.classId);
    },
    filialName() {
      const filial = this.filials.find(f => f.id === this.lesson.filialId);
      return filial ? filial.name : '';
    },
    teachers() {
      return this.managers
        .filter(m => this.lesson.teacherIds && this.lesson.teacherIds.includes(m.id))
        .map(m => m.name).join(', ');
    },
    roomName() {
      const room = this.rooms.find(r => r.id === this.lesson.roomId);
      return room ? room.name : '';
    },
    record() {
      return this.lesson.records && this.lesson.records.length > 0 ? this.lesson.records[0] : null;
    },
    canRecord() {
      return checkAllowRecord(this.lesson, this.currentUser);
    },
    canCancelRecord() {
      return checkCancelRecord(this.lesson);
    },
    isRecordFrozen() {
      return checkIfFrozen(this.lesson, this.currentUser);
    },
    hasVideo() {
      return this.lesson.params && this.lesson.params.videos;
    },
    hasWebinar() {
      return this.lesson.params.webinars;
    },
    classPayType() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl ? cl.payType : null;
    },
    classFreeRecords() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      return cl ? cl.freeRecords : null;
    },
    isPast() {
      const cl = this.classes.find(c => c.id === this.lesson.classId);
      if (!cl) {
        return false;
      }
      const filial = this.filials.find(f => f.id === cl.filialId);
      if (!filial) {
        return false;
      }
      const tzTime = moment.tz(`${this.lesson.date} ${this.lesson.beginTime}:00`, filial.timezone);
      const tzNow = moment().tz(filial.timezone);

      return tzTime < tzNow;
    },
    visited() {
      return this.lesson.status === 1 && this.record && this.record.visit;
    },
    lost() {
      return this.lesson.status === 1 && this.record && !this.record.visit;
    },
    markerColor() {
      if (this.visited) {
        return '#00aa00';
      }
      if (this.lost) {
        return '#ff0000';
      }
      if (this.isPast) {
        return '#aaaaaa';
      }
      if (this.record) {
        return this.UISettings.color;
      }
      return '#777777';
    },
    comment() {
      if (!this.lesson.comments || !this.lesson.comments.length) {
        return null;
      }

      const comments = this.lesson.comments.slice(0).sort((a, b) => {
        if (a.createdAt < b.createdAt) {
          return 1;
        }
        if (a.createdAt > b.createdAt) {
          return -1;
        }
        return 0;
      });

      return comments[0].comment;
    },
    missedLesson() {
      if (!this.record.missedRecord) return null;
      const cl = this.classes.find(({ id }) => id === this.record.missedRecord.classId);
      const c = this.courses.find(({ id }) => id === cl.courseId);
      const f = this.filials.find(({ id }) => id === cl.filialId);
      return {
        classTitle: `${c ? c.name : ''} ${cl ? cl.name : ''}`,
        filialName: f ? f.name : '',
        date: moment(this.record.missedRecord.date).format('DD.MM.YYYY'),
        teachers: this.managers
          .filter(m => this.record.missedRecord.teacherIds && this.record.missedRecord.teacherIds.includes(m.id))
          .map(m => m.name).join(', '),
      };
    },
    ...mapGetters(['classes', 'courses', 'filials', 'rooms', 'managers', 'currentUser', 'UISettings']),
  },
  methods: {
    ...mapMutations(['setCreateJoinDialog']),
    createRecord() {
      const targetClass = this.classes.find(({ id }) => id === this.lesson.classId);
      const { onlinePayment } = targetClass;
      const isPaymentForJoinCombined = onlinePayment.paymentForJoin === 'combined';
      const userIsNotRecord = !this.currentUser.joins
        .find(({ classId }) => classId === this.lesson.classId);

      if (isPaymentForJoinCombined && userIsNotRecord) {
        this.setCreateJoinDialog({
          filialId: targetClass.filialId,
          lessonIds: [this.lesson.id],
          lessons: [this.lesson],
          cl: targetClass,
        });
      } else this.createDialog = true;
    },
    changeRecord() {
      this.$emit('change');
      loadBaseInfo();
    },
    mark(type) {
      const { marks } = this.lesson;
      if (!marks || !marks.length) {
        return null;
      }
      const mark = marks.find(m => m.type === type);
      return mark ? mark.value : null;
    },
    answer(type) {
      const { answers } = this.lesson;
      if (!answers || !answers.length) {
        return null;
      }
      return answers.find(a => a.type === type);
    },
    task(type) {
      let result = 'ДЗ: ';
      let taskKey = 'homeTask';

      if (type === 'lesson') {
        taskKey = 'lessonTask';
        result = 'ЗУ: ';
      }

      const task = this.lesson[taskKey];

      if (!task && !this.mark(type)) {
        return '';
      }

      const answer = this.answer(type);

      if (task) {
        const obj = (answer) ? answerStatusMap[answer.status] : newAnswerStatus.new;
        if (!this.mark(type)) {
          result += obj.label;
        }

        const styles = `padding: 5px; margin-right: 3px; margin-bottom: 3px; background: ${obj.background} !important; text-align: center; color: ${obj.color}`;

        if (type === 'home') {
          this.stylesHome = styles;
        } else {
          this.stylesLesson = styles;
        }
      }

      if (this.mark(type)) {
        result += ` Оценка - ${this.mark(type)}`;
      }

      return result;
    },
  },
};
</script>

<style lang="less" scoped>
  .lesson {
    cursor: pointer;
    border: 0 solid #aaaaaa;

    &.lesson-recorded {
      border-left-width: 6px;
    }

    .lesson-icon-video {
      font-size: 14px;
      color: red;
    }

    .lesson-icon-webinar {
      padding-bottom: 1px;
      font-size: 16px;
      color: blue;
    }
  }

  .marker {
    max-width: 200px;
    display: flex;
    justify-content: center;

    &:nth-child(2) {
      margin-left: 7px;
    }
  }

  .lesson-task-flex {
    display: flex !important;
  }

  .lesson-icon-is-work-out {
    color: #FFFFFF;
    font-weight: 700;
    background-color: #9D5BF1;
    padding: 1px;
    padding-bottom: 0px;
    font-size: 16px;
    margin-right: 4px;
    margin-top: -1px;
  }

  @media (max-width: 959px) {
    .lesson-task-flex {
      display: none !important;
    }
  }
</style>
